import { Anchor, Modal } from "@mantine/core";
import { FormProvider, useForm } from "react-hook-form";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import Card from "src/components/shared/Card/Card";
import { getOrigin } from "src/environment";
import Logbook from "src/generator/Logbook/Logbook";
import { ButtonsWrapper, CardsContainer, PageContainer } from "src/styled";

import { useLogbookPreview } from "./LogbookPreview.hooks";

const LogbookPreview = () => {
  const methods = useForm();
  const {
    data,
    parts,
    customLinks,
    opened,
    onCardClick,
    onClose,
    selectedPartName,
  } = useLogbookPreview();

  return (
    <FormProvider {...methods}>
      <PageContainer>
        <Breadcrumbs customLinks={customLinks}>
          {data?.link && data?.linkName && (
            <ButtonsWrapper>
              <Anchor href={getOrigin() + `/${data.link}`} target="_blank">
                {data.linkName}
              </Anchor>
            </ButtonsWrapper>
          )}
        </Breadcrumbs>
        {data?.type === "logbook" && <Logbook />}
        {data?.type === "collection" && (
          <CardsContainer>
            {parts.map(part => (
              <Card
                key={part.lbname}
                cardName={part.lbname}
                cardDetails={part.title}
                onClick={() => onCardClick(part)}
              />
            ))}
          </CardsContainer>
        )}
      </PageContainer>
      <Modal
        size="90vw"
        opened={opened}
        onClose={onClose}
        withinPortal={false}
        title={selectedPartName}>
        <Logbook />
      </Modal>
    </FormProvider>
  );
};

export default LogbookPreview;
